<template>
    <a
        rel="noopener noreferrer"
        class="inline-block transition-transform duration-300 hover:-translate-y-0.5"
        :href="url"
        target="_blank"
    >
        <img :src="src" :alt="buttonText" class="h-14 w-auto" loading="lazy" fetchpriority="low" />
    </a>
</template>

<script>
export default {
    name: 'ButtonDonation',
    props: {
        username: {
            required: false,
            type: String,
            default: 'laurenjones',
        },
        buttonText: {
            required: false,
            type: String,
            default: 'Buy me a coffee',
        },
        buttonColor: {
            required: false,
            type: String,
            default: 'white',
        },
    },
    computed: {
        url() {
            return `https://www.buymeacoffee.com/${this.username}`;
        },
        src() {
            return `https://cdn.buymeacoffee.com/buttons/v2/default-${this.buttonColor}.png`;
        },
    },
};
</script>
